module.exports = __webpack_public_path__ + "assets/images/android_dl_prompt-598176d91ba9d64cc1bab8dc190e97eb.mp4";